import axiosServices from 'utils/axios';
import { ArticlePreviewDto } from './dto';

export const fetchArticlePreview = async (entryId: string): Promise<ArticlePreviewDto> => {
    const res = await axiosServices.get(`articles/${entryId}`);
    return res.data;
};
